<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入库管理列表
        </div>
        <div style="padding: 20px;"> 
            <div style="float:right;margin-bottom:10px">
                 <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
            </div>
            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                        <el-table-column prop="remarks" label="备注"></el-table-column>

                        <el-table-column prop="count" label="库存"></el-table-column>

                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="日期"></el-table-column>

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button type="primary"  size="small" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>
            <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>
        </div>
    </div>
</template>

<script>
    import Info from "./Info";
    // import Add from "./Add";
    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:true,
                showModalInfo:false,
                tableData:null,
                datetimerangeValue:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
            }
        },
        components:{
            Info
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end= new Date();
                const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
            },
            handleInfo(index, row) {
                this.$refs.myInfo.init(row);
                this.showModalInfo = !this.showModalInfo;
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"StockinDrug/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },


        }
    }
</script>

<style scoped>

</style>